import React from 'react';

var AlertPopup = React.createClass({
	componentDidMount: function() {
    	$('.modal__content').css({'position': 'fixed'});
  	},
	handleCloseClick: function(){
		this.props.alertPopup();
	},
	handleStopPropogation: function(e) {
		e.stopPropagation() 
	},
	render: function(){
		var result = [];
		if(this.props.errors.hasOwnProperty("data") && this.props.errors.data != null && typeof this.props.errors === "object"  && this.props.errors.hasOwnProperty("message") && this.props.errors.message.toLowerCase().indexOf("invalid") > -1){
			if (Object.keys(this.props.errors.data).length > 0 && this.props.errors.data.constructor === Object){
				for (var key in this.props.errors.data){
					result.push(
						<div key = {key}>
							<strong>File Name: </strong> {key}
							<br/>
							<strong>Error: </strong> {this.props.errors.data[key]}
							<br/>
							<br/>
						</div>
					);
				}
			}
		}
		return(	
			<div className="modal__mask" onClick= {this.props.errors.isLoading ? this.handleStopPropogation : this.handleCloseClick}>  
				{ this.props.errors.isLoading ? 
					<div style = {{"position": "fixed",  width:"780px", height:"650px", left:"60%", top:"50%", marginLeft:"-100px",  marginTop:"-200px"}}>
						    <i className="fa fa-spinner fa-pulse fa-3x fa-fw" style = {{"color": "white"}}></i>
						    <p style = {{"color": "white"}}>{this.props.errors.message}</p>
					</div> :
				<div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">{this.props.errors.error ? "Alert !" : "Success " }</h3>
				    <a href="javascript:void(0)" className="modal__close" onClick= {this.handleCloseClick}> 
				    	<i className="fa  fa-close"> </i>
				    </a>
				  </div>
				  <div className="modal__body clearfix">
				    <div>
					    <div className="form__row clearfix">
						    <p>{this.props.errors.message}</p>
					    </div>  
					  	{result}
					    <div className="buttons clearfix">
					      <button className="btn__lg bg-bright" onClick= {this.handleCloseClick}>Ok</button>
					    </div> 
					</div> 
				  </div>
				</div> }
			</div>
		);
	}
});

export {AlertPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/AlertPopup.jsx
 **/